"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'repair',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      getType: 0,
      typeUrl: ['agentapi/my_repair_reposts', 'agentapi/my_sttuf_repair_reposts'],
      statusArr: ['已报修', '维修中', '已修复'],
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.getType = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      var listQuery = Object.assign({}, this.listQuery, {
        start: this.listQuery.start - 1
      });
      this.$get(this.typeUrl[this.getType], listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    }
  }
};